// ── NAPLAN-style multistage exam ───────────────────────────
// Like the online NAPLAN tests, an exam is a series of short testlets: everyone starts on a middle-difficulty testlet
// and the score on each testlet routes the student to an easier, similar or harder next one. Each testlet spreads
// across topics. Proficiency then reflects the level reached, not just the raw percentage.
export const EXAM_TESTLETS = 3, TESTLET_SIZE = 6;
export const LEVEL_NAME = { 1: "Easier", 2: "Core", 3: "Harder" };
export function buildTestlet(pool, usedIds, level, n) {
  const shuffle = arr => [...arr].sort(() => Math.random() - 0.5);
  const avail = pool.filter(q => !usedIds.has(q.id));
  const picked = [], seenTopics = new Set(), have = new Set();
  // nearest difficulty first; within a difficulty, one question per topic before any topic repeats
  for (const dist of [0, 1, 2]) {
    const tier = shuffle(avail.filter(q => Math.abs((q.difficulty || 2) - level) === dist && !have.has(q.id)));
    for (const pass of [0, 1]) for (const q of tier) {
      if (picked.length >= n) break;
      if (have.has(q.id) || (pass === 0 && seenTopics.has(q.topic))) continue;
      picked.push(q); have.add(q.id); seenTopics.add(q.topic);
    }
    if (picked.length >= n) break;
  }
  return picked;
}
export function routeNextLevel(level, correctInTestlet, n) {
  if (correctInTestlet >= n - 1) return Math.min(3, level + 1);   // 5 or 6 of 6 → harder
  if (correctInTestlet <= Math.floor(n / 3)) return Math.max(1, level - 1); // 0–2 of 6 → easier
  return level;
}
export function routeProficiency(route, lastTestletCorrect, n) {
  const L = route[route.length - 1], strong = lastTestletCorrect >= Math.ceil(n * 2 / 3);
  if (L === 3) return strong ? "Exceeding" : "Strong";
  if (L === 2) return strong ? "Strong" : "Developing";
  return strong ? "Developing" : "Needs Support";
}
